import { joinPathsStringUtil } from 'packages/src'
import { REDUX_DOMAIN_LIST_SECTION_KEY } from '../../constants/key'

export default function getByProfileIdPathReduxUtil (path, profileId) {
  if (!profileId) {
    return path
  }
  // e.g. profileLogs.byProfileId.33624
  return joinPathsStringUtil(path,
    REDUX_DOMAIN_LIST_SECTION_KEY.BY_PROFILE_ID,
    profileId
  )
}
